import {customLog} from "./../../customLog.js";	
export const setCurrentUserData = "SET_CURRENT_USER_DATA";
export const setAvailableUsersData = "SET_AVAILABLE_USERS_DATA";
export const setAvailableCompositions = "SET_AVAILABLE_COMPOSITIONS";
export const setAvailableContexts = "SET_CONTEXT_DATA";
export const setAvailableTags = "SET_AVAILABLE_TAGS";
export const K_setAvailableLists = "SET_AVAILABLE_LISTS";
export const K_setAvailablePrefabAudio = "SET_AVAILABLE_PREFAB_AUDIO";
export const k_removeAllData = "REMOVE_ALL_DATA";
export const k_setRevisions = "SET_REVISIONS";
export const k_clearRevisions = "CLEAR_REVISIONS";

export function setCurrentUser(userObj)
{
	return {
		type: setCurrentUserData,
		payload: userObj
	};
}

export function removeAllLoadedData()
{
	return {
		type: k_removeAllData,
		payload: null
	};
}

export function setTags(tagsList)
{
	return {
		type: setAvailableTags,
		payload: tagsList
	};
}

export function setContexts(contextsList)
{
	return {
		type: setAvailableContexts,
		payload: contextsList
	};
}

export function setUsers(usersList)
{
	return {
		type: setAvailableUsersData,
		payload: usersList
	};
}

export function setCompositions(compositionsList)
{
	return {
		type: setAvailableCompositions,
		payload: compositionsList
	};
}

export function setLists(lists)
{
	return {
		type: K_setAvailableLists,
		payload: lists,
	}
}

export function setPrefabAudio(prefabAudio)
{
	//customLog("Setting prefab audio: ", prefabAudio);
	return {
		type: K_setAvailablePrefabAudio,
		payload: prefabAudio,
	}
}

export function setRevisions(revisions, merge = true)
{
	return {
		type: k_setRevisions,
		payload: {revisions, merge},
	}
}

export function clearRevisions()
{
	return {
		type: k_clearRevisions
	}
}




// WEBPACK FOOTER //
// ./js/stateStuff/actions/updateDataActions.js